/**
 * The rail's **More** menu (`specs/M1-B10-shell-chrome.md` §4.1).
 *
 * Measured `[c:rail-more]`: **220 px** wide, five 32 px rows —
 * `My work · Template center · Docs hub · Autopilot hub` | `Customize menu`. Ours keeps the
 * three that exist here; `Autopilot hub` (monday's AI surface) and `Customize menu` (which
 * reorders monday's own AI rail slots) are **absent**, per §3.2.
 *
 * Before B10 the rail's More slot swapped the pane's *title* to "More" and changed nothing
 * else — it was the only rail entry that did nothing at all.
 */
import { useRef, useState } from 'react';
import { useNavigate } from 'react-router';
import { Menu, type MenuEntry } from '../board-view/table/menus/Menu';
import { TemplatePicker } from '../templates';

export const RAIL_MORE_MENU_WIDTH = 220;

export function RailMoreMenu({
  workspaceId,
  x,
  y,
  onClose,
}: {
  workspaceId: string | null;
  x: number;
  y: number;
  onClose(): void;
}) {
  const navigate = useNavigate();
  const [templates, setTemplates] = useState(false);
  /** See `SidebarRowMenu`: `Menu` closes before the state update lands. */
  const chose = useRef(false);

  if (templates) {
    return <TemplatePicker workspaceId={workspaceId} onClose={onClose} />;
  }

  const entries: MenuEntry[] = [
    {
      id: 'my-work',
      label: 'My work',
      'data-testid': 'more-my-work',
      onSelect: () => navigate('/my_work'),
    },
    {
      id: 'templates',
      label: 'Template center',
      'data-testid': 'more-templates',
      onSelect: () => {
        chose.current = true;
        setTemplates(true);
      },
    },
    { id: 'docs', label: 'Docs hub', 'data-testid': 'more-docs', onSelect: () => navigate('/docs') },
  ];

  return (
    <Menu
      entries={entries}
      x={x}
      y={y}
      width={RAIL_MORE_MENU_WIDTH}
      label="More"
      onClose={() => {
        if (!chose.current) onClose();
      }}
    />
  );
}
